import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    width: 25rem;
    height: 30vh;
    padding: 1rem;
`;

export const Close = styled.div`
    position: fixed;
    cursor: pointer;
    right: 0;
    top: 0;
    padding: 1rem;
`;

export const Content = styled.div`

`;

